import React, { createContext, useContext, useReducer } from 'react';

export const StateContext = createContext();

export const StateProvider = ({ children }) => {
    const initialState = {
        navBarOptions: { menu: [], station: null, product: null },
        currentOpenStation: {},
        showMenuButton: false,
        editFavoritesMode: null
    };

    const reducer = (state, action) => {
        switch (action.type) {
            case 'changeNavBarOptions':
                return {
                    ...state,
                    navBarOptions: action.newOptions
                };
            case 'changeCurrentOpenStation':
                return {
                    ...state,
                    currentOpenStation: action.newStation
                };
            case 'setShowMenuButton':
                return {
                    ...state,
                    showMenuButton: action.newState
                };
            case 'toggleFavoritesMode':
                return {
                    ...state,
                    editFavoritesMode: action.newState
                }; default:
                return state;
        }
    }

    return (
        <StateContext.Provider value={useReducer(reducer, initialState)}>
            {children}
        </StateContext.Provider>
    )
}

export const useStateValue = () => useContext(StateContext);